import { defineComponent } from "vue";
import { ChallengePickImage } from "@/data/challenges/challengePickImage";
import Image from "@/components/core/Image.vue";
import Button from '@/components/core/Button.vue';
import router from '@/router';
import DropZone from "@/components/core/DropZone.vue";
import modalHandler from "@/data/modalHandler";
import SymbolSolution from "@/components/symbols/solution.vue";
import audioHandler from "@/data/audioHandler";
import pageHookMixin from "@/data/pageHookMixin";
export default defineComponent({
    name: 'ChallengePickImage',
    mixins: [pageHookMixin],
    components: {
        SymbolSolution,
        DropZone,
        Image,
        Button
    },
    props: {
        challenge: {
            type: ChallengePickImage
        },
        forwardUrl: {
            type: String
        },
        showMotivationModal: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dropZoneState: this.challenge?.getDropZoneState() || {}
        };
    },
    watch: {
        buttonColor(newState, oldState) {
            if (newState === 'orange' && oldState !== newState) {
                audioHandler.play('select');
            }
        }
    },
    computed: {
        solved() {
            if (this.challenge) {
                return this.challenge.state === 'solved';
            }
            return false;
        },
        buttonColor() {
            if (this.challenge) {
                if (this.solved) {
                    return 'green';
                }
                if (this.challenge?.state === 'chosen') {
                    return 'orange';
                }
            }
            return 'gray';
        },
        imageHorizontalElements() {
            const nrOfItems = this.challenge?.getNumberOfItems() || 0;
            if (nrOfItems > 3) {
                return 'quadruple';
            }
            if (nrOfItems > 2) {
                return 'triple';
            }
            return 'double';
        }
    },
    methods: {
        onScreenUpdate() {
            router.go(0);
        },
        updateDropZone() {
            if (this.challenge && this.challenge.getNumberOfDropZones() < 1) {
                const dropZone = this.$refs.dz?.$el;
                if (dropZone) {
                    this.challenge?.registerDropZone(dropZone.getBoundingClientRect());
                }
            }
        },
        draggableOnMove(itemKey, cursorX, cursorY) {
            this.updateDropZone();
            this.challenge?.selectItemDropZone(itemKey, cursorX, cursorY);
            this.dropZoneState = this.challenge?.getDropZoneState() || {};
        },
        onForwardButtonClick() {
            if (this.challenge?.state === 'solved' && this.forwardUrl) {
                if (this.showMotivationModal) {
                    modalHandler.show('motivation', {
                        forwardUrl: this.forwardUrl
                    });
                }
                else {
                    router.replace(this.forwardUrl);
                }
            }
            if (this.challenge?.state === 'chosen') {
                this.dropZoneState = this.challenge?.getDropZoneState() || {};
                this.challenge.evaluate();
            }
        }
    }
});
